export default [
  {
    dialog: false,
    index: '6th',
    date: '2015/12/17',
    songTitle: 'Caprice Butterfly',
    movieTitle: '【結月ゆかりV4】Caprice Butterfly【オリジナル】',
    imgSrc: '/assets/06_caprice_butterfly.jpg',
    srcYoutube: 'https://www.youtube.com/embed/KAN_wPiRnMY?rel=0',
    srcNico: 'https://embed.nicovideo.jp/watch/sm27807924/script?w=640&h=360',
    hrefYoutube: 'https://www.youtube.com/watch?v=KAN_wPiRnMY',
    hrefNico: 'http://www.nicovideo.jp/watch/sm27807924',
    discription:
      `
      この曲を最初に作りはじめたのは 2014年5月頃、<br>
      日常に忙殺されていたらあっという間に年月が経ってしまいました。<br>
      そういう意味では、制作期間一年半の超大作(?)です。<br>
      どうぞお聴きください。<br>
      <br>
      『 何千回も何万回も伝えよう、君が「好き」 』
      `
    // discription:
    //   `
    //   ★☆ Special Thanks ☆★<br>
    //   Illustration: 狐白(<a href="http://www.nicovideo.jp/user/761624">user/illust/761624</a>) <a href="https://twitter.com/y_kohaku_">@y_kohaku_</a><br>
    //   Guitar Solo: ほーちゃん <a href="https://twitter.com/tak_kyama">@tak_kyama</a><br>
    //   Movie: てりる<br>
    //   <br>
    //   Music&Lyrics: MistDewing(<a href="http://www.nicovideo.jp/mylist/31994055">mylist/31994055</a>) <a href="https://twitter.com/MistDewing">@MistDewing</a><br>
    //   <br>
    //   この曲を最初に作りはじめたのは 2014年5月頃、<br>
    //   日常に忙殺されていたらあっという間に年月が経ってしまいました。<br>
    //   そういう意味では、制作期間一年半の超大作(?)です。<br>
    //   どうぞお聴きください。<br>
    //   <br>
    //   『 何千回も何万回も伝えよう、君が「好き」 』
    //   `
  },
  {
    dialog: false,
    index: '5th',
    date: '2015/05/14',
    songTitle: 'スレチガイワルツ＋',
    movieTitle: '【kokone 心響】 スレチガイワルツ＋ 【オリジナル】',
    imgSrc: '/assets/5th.png',
    srcYoutube: 'https://www.youtube.com/embed/mz2lbz_EYXs?rel=0',
    src: 'https://embed.nicovideo.jp/watch/sm26247717/script?w=640&h=360',
    hrefYoutube: 'https://www.youtube.com/watch?v=mz2lbz_EYXs',
    hrefNico: 'http://www.nicovideo.jp/watch/sm26247717',
    discription:
      `
      何度もケンカして、仲直りを繰り返して、その先にあるものはなんだろね？<br>
      ぼくらは、スレチガイワルツを踊る<br>
      <br>
      2014年11月に参加させていただきましたコンピレーションアルバム<br>
      「ここねくしょん!」収録曲です。
      `
    // discription:
    //   `
    //   何度もケンカして、仲直りを繰り返して、その先にあるものはなんだろね？<br>
    //   ぼくらは、スレチガイワルツを踊る<br>
    //   <br>
    //   ◆Songwriting: MistDewing <a href="http://www.nicovideo.jp/mylist/31994055">mylist/31994055</a><br>
    //   ◇Illustration: みなと<br>
    //   ◆Movie: てりる<br>
    //   <br>
    //   2014年11月に参加させていただきましたコンピレーションアルバム<br>
    //   「ここねくしょん!」収録曲です。
    //   `
  },
  {
    dialog: false,
    index: '4th',
    date: '2014/02/23',
    songTitle: '櫛',
    movieTitle: '【kokone 心響】 櫛 - くし - 【オリジナル】',
    imgSrc: '/assets/4th.jpg',
    srcYoutube: 'https://www.youtube.com/embed/BLB5P3yE4Iw?rel=0',
    src: 'https://embed.nicovideo.jp/watch/sm22949489/script?w=640&h=360',
    hrefYoutube: 'https://www.youtube.com/watch?v=BLB5P3yE4Iw',
    hrefNico: 'http://www.nicovideo.jp/watch/sm22949489',
    discription:
      `
      kokoneさんに歌ってもらいました。<br>
      <br>
      ★3月に聴きたい曲★<br>
      <br>
      一緒に過ごせる時間も残りわずか<br>
      伝えたい"想い"や"ありがとう"はありますか？<br>
      <br>
      10年以上会わなくなるかもしれない<br>
      もう二度と会うことはないかもしれない<br>
      <br>
      あなたの知る誰かは、あなたの知らない誰かになってゆくかもしれない<br>
      それとも、あなたが変わってしまうのかもしれない<br>
      <br>
      あなたという髪は、日々、梳(くしけず)られていく<br>
      あなたにとっての櫛(くし)はなんですか？<br>
      <br>
      願わくば伝えられるときに伝えて欲しい<br>
      そんな曲です。
      `
    // discription:
    //   `
    //   kokoneさんに歌ってもらいました。<br>
    //   ( ﾟ∀ﾟ)o彡°黒髪ローング！！<br>
    //   ( ﾟ∀ﾟ)o彡°黒髪ローング！！<br>
    //   <br>
    //   ★3月に聴きたい曲★<br>
    //   <br>
    //   一緒に過ごせる時間も残りわずか<br>
    //   伝えたい"想い"や"ありがとう"はありますか？<br>
    //   <br>
    //   10年以上会わなくなるかもしれない<br>
    //   もう二度と会うことはないかもしれない<br>
    //   <br>
    //   あなたの知る誰かは、あなたの知らない誰かになってゆくかもしれない<br>
    //   それとも、あなたが変わってしまうのかもしれない<br>
    //   <br>
    //   あなたという髪は、日々、梳(くしけず)られていく<br>
    //   あなたにとっての櫛(くし)はなんですか？<br>
    //   <br>
    //   願わくば伝えられるときに伝えて欲しい<br>
    //   そんな曲です。<br>
    //   <br>
    //   ★Songwriting: MistDewing <a href="http://www.nicovideo.jp/mylist/31994055">mylist/31994055</a><br>
    //   ★Movie: てりる
    //   `
  },
  {
    dialog: false,
    index: '3rd',
    date: '2013/09/25',
    songTitle: 'トワイライトシューティングスター',
    movieTitle: '【結月ゆかり】トワイライトシューティングスター【オリジナル】',
    imgSrc: '/assets/3rd.jpg',
    srcYoutube: 'https://www.youtube.com/embed/bDyoZr3CqN4?rel=0',
    src: 'https://embed.nicovideo.jp/watch/sm21909439/script?w=640&h=360',
    hrefYoutube: 'https://www.youtube.com/watch?v=bDyoZr3CqN4',
    hrefNico: 'http://www.nicovideo.jp/watch/sm21909439',
    discription:
      `
      なにかをアウトプットしていないと生きている実感を持てない時代<br>
      なにかを紡ぎだして誰かに見てもらって認めてもらわないと"生"を実感できない時代<br>
      SNSでつながって昔よりはるかに"夢"が現実に近づいたように見える時代<br>
      現代は誰もが数多ある生き方の選択に翻弄されて不器用にもがいてる<br>
      <br>
      ここにも世界は違えど涙の意味を隠す道化な少女がいた<br>
      <br>
      なーんて考えたことをきっかけに作りました。<br>
      "切な系疾走ロック"です。最後まで聴いていただけたら幸いです。<br>
      `
    // discription:
    //   `
    //   なにかをアウトプットしていないと生きている実感を持てない時代<br>
    //   なにかを紡ぎだして誰かに見てもらって認めてもらわないと"生"を実感できない時代<br>
    //   SNSでつながって昔よりはるかに"夢"が現実に近づいたように見える時代<br>
    //   現代は誰もが数多ある生き方の選択に翻弄されて不器用にもがいてる<br>
    //   <br>
    //   ここにも世界は違えど涙の意味を隠す道化な少女がいた<br>
    //   <br>
    //   なーんて考えたことをきっかけに作りました。<br>
    //   "切な系疾走ロック"です。最後まで聴いていただけたら幸いです。<br>
    //   <br>
    //   ★Songwriting: MistDewing <a href="http://www.nicovideo.jp/mylist/31994055">mylist/31994055</a><br>
    //   ☆Illustration: 狐白 <a href="http://seiga.nicovideo.jp/user/illust/761624">user/illust/761624</a><br>
    //   ★Movie: てりる
    //   `
  },
  {
    dialog: false,
    index: '2nd',
    date: '2013/02/26',
    songTitle: 'あるがままの君がいいよ、そのままで世界は美しい',
    movieTitle: '【結月ゆかり】あるがままの君がいいよ、そのままで世界は美しい',
    imgSrc: '/assets/2nd.jpg',
    srcYoutube: 'https://www.youtube.com/embed/nvhrV2UMrEw?rel=0',
    src: 'https://embed.nicovideo.jp/watch/sm20192710/script?w=640&h=360',
    hrefYoutube: 'https://www.youtube.com/watch?v=nvhrV2UMrEw',
    hrefNico: 'http://www.nicovideo.jp/watch/sm20192710',
    discription:
      `
      君が見ていた世界は偽りだったのかもしれない<br>
      君と過ごしたあの子もまた、偽りだったのかもしれない<br>
      <br>
      今宵朧月<br>
      <br>
      その違和感を忘れると今在る世界はもっと美しいのかもしれない<br>
      <br>
      あるがままの世界を好きになろう<br>
      そのままで世界は美しい<br>
      <br>
      生まれた意味を問うことも<br>
      存在を証明することも今宵限り<br>
      <br>
      月が満ちた夜に世界は交じわり<br>
      境界線に女神がたたずむ<br>
      <br>
      世界は隔たれ 少年少女も別けられ<br>
      月と海が二人の想いをつなぐ<br>
      <br>
      そんな曲です<br>
      <br>
      This song is a sequel of "ツキヒカリに照らされた君の横顔を想う"
      `
    // discription:
    //   `
    //   君が見ていた世界は偽りだったのかもしれない<br>
    //   君と過ごしたあの子もまた、偽りだったのかもしれない<br>
    //   <br>
    //   今宵朧月<br>
    //   <br>
    //   その違和感を忘れると今在る世界はもっと美しいのかもしれない<br>
    //   <br>
    //   あるがままの世界を好きになろう<br>
    //   そのままで世界は美しい<br>
    //   <br>
    //   生まれた意味を問うことも<br>
    //   存在を証明することも今宵限り<br>
    //   <br>
    //   月が満ちた夜に世界は交じわり<br>
    //   境界線に女神がたたずむ<br>
    //   <br>
    //   世界は隔たれ 少年少女も別けられ<br>
    //   月と海が二人の想いをつなぐ<br>
    //   <br>
    //   そんな曲です<br>
    //   <br>
    //   This song is a sequel of "ツキヒカリに照らされた君の横顔を想う"<br>
    //   <br>
    //   ★作詞・作曲 ⇒ MistDewing <a href="http://www.nicovideo.jp/mylist/31994055">mylist/31994055</a><br>
    //   ☆イラスト ⇒ 狐白 <a href="http://seiga.nicovideo.jp/user/illust/761624">user/illust/761624</a>
    //   `
  },
  {
    dialog: false,
    index: '1st',
    date: '2013/02/26',
    songTitle: 'ツキヒカリに照らされた君の横顔を想う',
    movieTitle: '【初音ミク】ツキヒカリに照らされた君の横顔を想う【オリジナル】',
    imgSrc: '/assets/1st.jpg',
    srcYoutube: 'https://www.youtube.com/embed/HBUzTsE6BmA?rel=0',
    src: 'https://embed.nicovideo.jp/watch/sm20192587/script?w=640&h=360',
    hrefYoutube: 'https://www.youtube.com/watch?v=HBUzTsE6BmA',
    hrefNico: 'http://www.nicovideo.jp/watch/sm20192587',
    discription:
      `
      幼い頃に海で出会った少女<br>
      少女に表情はなく、この世のすべてを憎むようでした<br>
      <br>
      今宵望月<br>
      <br>
      ツキヒカリに照らされたその少女は<br>
      ただ、ただ美しかったのでした<br>
      <br>
      「君は笑えるよ 知ってるから」<br>
      <br>
      少年は少女の笑顔を取り戻そうと<br>
      少女を連れ出しました<br>
      <br>
      月の加護もあって少年は少女の笑顔を取り戻しました<br>
      けれど、笑顔を知った少女は、<br>
      <br>
      もう"その世界"の"少女"ではありませんでした<br>
      <br>
      そんな曲です<br>
      <br>
      This song is to be continued, next song is "あるがままの君がいいよ、そのままで世界は美しい"
      `
    // discription:
    //   `
    //   幼い頃に海で出会った少女<br>
    //   少女に表情はなく、この世のすべてを憎むようでした<br>
    //   <br>
    //   今宵望月<br>
    //   <br>
    //   ツキヒカリに照らされたその少女は<br>
    //   ただ、ただ美しかったのでした<br>
    //   <br>
    //   「君は笑えるよ 知ってるから」<br>
    //   <br>
    //   少年は少女の笑顔を取り戻そうと<br>
    //   少女を連れ出しました<br>
    //   <br>
    //   月の加護もあって少年は少女の笑顔を取り戻しました<br>
    //   けれど、笑顔を知った少女は、<br>
    //   <br>
    //   もう"その世界"の"少女"ではありませんでした<br>
    //   <br>
    //   そんな曲です<br>
    //   <br>
    //   This song is to be continued, next song is "あるがままの君がいいよ、そのままで世界は美しい"
    //   <br>
    //   ★作詞・作曲 ⇒ MistDewing <a href="http://www.nicovideo.jp/mylist/31994055">mylist/31994055</a><br>
    //   ☆イラスト ⇒ 狐白 <a href="http://seiga.nicovideo.jp/user/illust/761624">user/illust/761624</a>
    //   `
  }
]
